import { createFileRoute } from '@tanstack/react-router'

import { JellyIcon } from '@/components/icons'
import { AppButton, SectionLabel } from '@/components/shared'
import { AppLink as Link } from '@/components/shell'
import { BILLING_ROWS, CARD, INVOICES } from '@/mocks/klient/profilFakturace'

export const Route = createFileRoute('/klient/profil/fakturace')({
  head: () => ({ meta: [{ title: 'Fakturace a faktury · Aplikace Bitez' }] }),
  component: KlientFakturace,
})

function KlientFakturace() {
  return (
    <div className="px-4 pt-4 pb-6">
      <Link
        href="/klient/profil"
        className="-ml-1 flex w-fit items-center gap-1.5 rounded-full px-1 py-1 text-[10px] font-bold tracking-widest text-ink/40 uppercase transition-colors duration-150 hover:text-ink/70"
      >
        <JellyIcon name="arrow-left" className="size-3" />
        Profil
      </Link>

      <h1 className="font-display mt-3 text-2xl leading-[0.9] uppercase">Fakturace a faktury</h1>

      <section className="animate-rise-up mt-6">
        <SectionLabel>Platební metoda</SectionLabel>
        <div className="mt-3 rounded-3xl bg-white p-5 shadow-sm">
          <div className="flex items-center gap-3">
            <span
              aria-hidden
              className="flex size-10 shrink-0 items-center justify-center rounded-full bg-brand/10"
            >
              <JellyIcon name="money-bill" variant="fill" className="size-4 text-brand" />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-bold">
                {CARD.brand} •••• {CARD.last4}
              </p>
              <p className="text-[10px] font-semibold text-ink/45">Platí do {CARD.expires}</p>
            </div>
          </div>
          <p className="mt-3.5 text-[10px] leading-relaxed font-semibold text-ink/45">
            Balíček se strhává týdně dopředu. Zrušit můžete kdykoliv s týdenní výpovědí.
          </p>
          <AppButton variant="quiet" className="mt-3.5 w-full">
            Změnit kartu
          </AppButton>
        </div>
      </section>

      <section className="animate-rise-up mt-8" style={{ animationDelay: '60ms' }}>
        <SectionLabel>Fakturační údaje</SectionLabel>
        <div className="mt-3 space-y-2.5 rounded-3xl bg-white p-5 shadow-sm">
          {BILLING_ROWS.map((row) => (
            <p key={row.label} className="flex items-baseline gap-1.5 text-sm">
              <span className="text-ink/70">{row.label}</span>
              <span aria-hidden className="min-w-4 flex-1 border-b-2 border-dotted border-ink/15" />
              <span className="font-bold whitespace-nowrap">{row.value}</span>
            </p>
          ))}
          <div className="pt-1.5">
            <AppButton variant="quiet" className="w-full">
              Upravit údaje
            </AppButton>
          </div>
        </div>
      </section>

      <section className="animate-rise-up mt-8" style={{ animationDelay: '120ms' }}>
        <SectionLabel>Faktury</SectionLabel>
        <div className="mt-3 space-y-3.5">
          {INVOICES.map((invoice) => (
            <button
              key={invoice.period}
              type="button"
              className="group flex w-full cursor-pointer items-center gap-3 text-left"
            >
              <span
                aria-hidden
                className="flex size-9 shrink-0 items-center justify-center rounded-full bg-success/10"
              >
                <JellyIcon name="check" variant="fill" className="size-3.5 text-success" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-xs font-bold">{invoice.period}</span>
                <span className="block text-[10px] font-semibold text-ink/45">
                  Vystaveno {invoice.issued} · zaplaceno
                </span>
              </span>
              <span className="shrink-0 text-xs font-bold">{invoice.amount}</span>
              <JellyIcon
                name="arrow-down-to-line"
                className="size-3.5 shrink-0 text-ink/40 transition-transform duration-200 group-hover:translate-y-0.5"
              />
            </button>
          ))}
        </div>
      </section>
    </div>
  )
}
